<script>
export default {
  props: {
    challenge: {
      type: Object,
      required: true
    }
  },

  data() {
    return {
      loading: false
    }
  }
}
</script>

<template>
  <section class="modal-card">
		<article class="modal-card-body has-text-centered">
			<figure>
				<img src="../assets/img/challenge_ok.png">
			</figure>
			<h3 class="is-size-6" v-t="'challenges.quizz.your_challenge'"></h3>
      <h4 class="title is-5">{{ challenge.name }}</h4>
			<router-link class="button is-info"
				:class="{'is-loading': loading}"
        :to="{name: 'challenge', params: {id: challenge.slug}}"
        @click.native="$emit('close')"
        v-t="'buttons.im_interested'">
			</router-link>
			<button
        class="button is-text is-text-danger"
        @click="$emit('close')"
        v-t="'buttons.im_not_interested'">
      </button>
		</article>
  </section>
</template>

<style lang="scss" scoped>
	figure {
		margin: -20px -20px 20px;
		padding: pxToEm(17) pxToEm(40);
		background: #fee886;
  }

  h3 {
    margin-bottom: pxToEm(10);
    font-weight: 500;
    color: $grey-darker;
  }
  
  h4.title.is-4 {
    margin-bottom: pxToEm(60);
    color: $grey;
  }

  .button {
    width: 240px;
    max-width: 100%;
  }
</style>



// WEBPACK FOOTER //
// ChallengePreview.vue?1d170efa